import React from "react"

class Page extends React.Component {
  render(){
    return <div className="grid-x grid-padding-x"></div>
  }
}

export default Page
